import { Grid }                   from '@mui/material';
import qs                         from 'qs';
import React, { FC }              from 'react';
import { useLocation }            from 'react-router-dom';
import { useFetchSelectedFamily } from '../../../../shared/components/SelectFamily/queries';
import { ActivityItems }          from '../../../Activity/ActivityItems';
import { ActivityPageHeader }     from '../../../MyFamilyCore/shared/styles';
import { ActivitiesMenu }         from './ActivitiesMenu';

export const MembersActivity: FC = () => {
  const { search } = useLocation();
  const params: any = qs.parse(search, { ignoreQueryPrefix: true });
  const familyMemberId = params?.id as string;
  const { data: family } = useFetchSelectedFamily();

  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        md={3}
      >
        <ActivityPageHeader>Summary</ActivityPageHeader>

        <ActivitiesMenu
          familyId={family?.id}
          familyMemberId={familyMemberId}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={9}
      >
        <ActivityItems
          familyId={family?.id}
          familyMemberId={familyMemberId}
        />
      </Grid>
    </Grid>
  );
};
